var differs = [];
export var addDiffer = function addDiffer(diff) {
  return differs.push(diff);
};
export var resetDiffers = function resetDiffers() {
  return differs = [];
};
export var drainDifference = function drainDifference() {
  var d = differs;
  resetDiffers();
  return d;
};